import { Link } from 'react-router-dom'

export default function MainButton(props) {

  return (
    <div>
      {props.color ? (
        <button type="submit" style = {{backgroundColor: props.color}} className={`w-full text-white bg-${props.color}-primary hover:bg-${props.color}-primary focus:ring-4 focus:outline-none focus:ring-${props.color}-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>{props.text}</button>
      ) : (
        <button type="submit" className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">{props.text}</button>
      )}
    </div>

  )
}
